import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getBreachStatusList as getBreachStatusListApi } from '../../helpers/breach_status/api_helper';

export const getBreachStatusList = createAsyncThunk(
    'breachStatus/getBreachStatusList',
    async params => {
        try {
            const response = await getBreachStatusListApi(params);
            return response.data || response;
        } catch (error) {
            toast.error('Error al obtener estados de incumplimiento.', { autoClose: 3000 });
            throw new Error(error);
        }
    }
);
